import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  username: string
  email?: string
  fullName: string
  role: string
  studentId?: string
  faculty?: string
  className?: string
  phone?: string
  joinedAt?: string
  notes?: string
  departmentId?: string
  avatar?: string
  mustChangePassword?: boolean
  legalAcceptanceRequired?: boolean
  accountDeletionPending?: boolean
  accountDeletionScheduledAt?: string | null
  departmentStatus?: 'active' | 'pending_verification' | 'disabled'
  verificationStatus?: 'unverified' | 'pending' | 'verified' | 'rejected'
  subscriptionStatus?: 'legacy' | 'trial_active' | 'trial_readonly' | 'activation_pending' | 'formal' | 'expired'
}

export interface DepartmentContext {
  departmentId: string
  departmentName: string
  schoolId: string
  schoolName: string
  memberId: string
  memberName: string
  role: string
  departmentStatus?: 'active' | 'pending_verification' | 'disabled'
  verificationStatus?: 'unverified' | 'pending' | 'verified' | 'rejected'
  subscriptionStatus?: 'legacy' | 'trial_active' | 'trial_readonly' | 'activation_pending' | 'formal' | 'expired'
}

interface AuthState {
  user: User | null
  token: string | null
  csrfToken: string | null
  cloudMode: boolean
  contexts: DepartmentContext[]
  loading: boolean
  setUser: (user: User | null) => void
  setToken: (token: string | null) => void
  setCsrfToken: (csrfToken: string | null) => void
  setCloudMode: (cloudMode: boolean) => void
  setContexts: (contexts: DepartmentContext[]) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      csrfToken: null,
      cloudMode: false,
      contexts: [],
      loading: false,
      setUser: (user) => set({ user }),
      setToken: (token) => set({ token }),
      setCsrfToken: (csrfToken) => set({ csrfToken }),
      setCloudMode: (cloudMode) => set({ cloudMode }),
      setContexts: (contexts) => set({ contexts }),
      setLoading: (loading) => set({ loading }),
      logout: () => set({ user: null, token: null, csrfToken: null, contexts: [] })
    }),
    {
      name: 'auth-storage'
    }
  )
)
